// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"92d415e0","513":"cdd49150","787":"cc6e780b"}[chunkId] + ".chunk.js";
};